export default __webpack_public_path__ + "static/media/closeVideoButton.d4c30f2b.svg";